import React from 'react';

export default function BrandLogo({ size = 'normal', showSubtitle = true }) {
  const isLarge = size === 'large';
  
  return (
    <div className="flex items-center space-x-1.5 sm:space-x-2.5 group cursor-pointer select-none">
      {/* Luxury Gold Crest Shield with Roman Columns */}
      <div className={`relative ${isLarge ? 'w-12 h-12 sm:w-14 sm:h-14' : 'w-8 h-8 sm:w-9 sm:h-9 xl:w-10 xl:h-10'} flex items-center justify-center shrink-0`}>
        {/* Ambient glow */}
        <div className="absolute inset-0 bg-[#c59b27]/20 blur-md rounded-lg group-hover:bg-[#c59b27]/30 transition-all duration-300" />
        
        {/* Shield Border */}
        <div className="relative w-full h-full rounded-lg border border-[#c59b27]/50 bg-gradient-to-b from-[#141d2f] via-[#0c1322] to-[#070b14] flex items-center justify-center p-1.5 sm:p-2 shadow-lg shadow-black/60 group-hover:border-[#e5c07b] transition-all">
          <svg
            viewBox="0 0 40 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full text-[#c59b27] group-hover:text-[#f3e5ab] transition-colors"
          >
            {/* Outer Shield Outline */}
            <path
              d="M20 2L36 7.5V20C36 30.5 29.5 38.5 20 42C10.5 38.5 4 30.5 4 20V7.5L20 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {/* Inner Roman Pillars / Columns */}
            <path
              d="M13 13V29M20 13V29M27 13V29"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            {/* Pediment Arch and Base */}
            <path
              d="M10 13H30M10 29H30M11 9H29"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      {/* Brand Typography: JIZZAX ADVOKATLARI */}
      <div className="flex flex-col min-w-0">
        <span className={`font-serif ${isLarge ? 'text-xl sm:text-2xl' : 'text-xs sm:text-base xl:text-lg'} font-bold tracking-[0.08em] sm:tracking-[0.14em] text-slate-100 group-hover:text-amber-100 transition-colors uppercase leading-none`}>
          JIZZAX
        </span>
        {showSubtitle && (
          <span className="text-[6px] sm:text-[8px] xl:text-[9px] uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#c59b27] font-semibold mt-0.5 leading-none">
            ADVOKATLARI
          </span>
        )}
      </div>
    </div>
  );
}
